import { useGetCoverEditorQuery } from '../../../redux/api/fymAPI';

/**
 * The version of the cover editor that is the cover of the song now (`song.coverDesignUuid` of the
 * editor answer), for the cover field: "Edit cover" or "Design a new cover". It reads only for a
 * song with a cover; `undefined` while it loads or when it is not read.
 */
export function useCoverDesignOfSong(input: {
  accountId: number;
  catalogItemUuid: string;
  hasCover: boolean;
  enabled: boolean;
}): string | null | undefined {
  const { data } = useGetCoverEditorQuery(
    { accountId: input.accountId, catalogItemUuid: input.catalogItemUuid },
    { skip: !input.enabled || !input.hasCover }
  );
  return data?.song.coverDesignUuid;
}
